import axios from "axios";

// Global cache outside the function so it persists across all page mounts
let cachedPromise: Promise<any> | null = null;
let cacheTime = 0;
const CACHE_DURATION = 60000; // 1 minute (60,000 ms)

export default function GetNotificationAdminNoRead() {
    const urlShownotification = `${process.env.REACT_APP_PHP_APP_URL}/admin/notificationNoRead`;

    const GetNotification = () => {
        const now = Date.now();
        
        // Return the cached promise if it exists and hasn't expired
        if (cachedPromise && (now - cacheTime < CACHE_DURATION)) {
            return cachedPromise;
        }

        // Otherwise, fetch and cache the new promise
        cachedPromise = axios.get(urlShownotification).catch((error) => {
            cachedPromise = null; // Clear cache on error so it retries
            throw error;
        });
        cacheTime = now;

        return cachedPromise;
    };

    const ClearCache = () => {
        cachedPromise = null;
        cacheTime = 0;
    };

    return {
        GetNotification,
        ClearCache
    };
}